/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Box, TextField } from '@material-ui/core';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

function PaginationBox({ array, handleClick, handleBlur, count }) {
  const [value, setValue] = useState(count);
  const handleChange = (value) => setValue(value);

  const handleInputBlur = (e) => {
    const corrected = handleBlur(e.target.value); 
    setValue(corrected);
  };

  useEffect(() => {
    setValue(count);
  }, [count]);

  return (
    <Box className='alone-pagination mb-2'>
      {' '}
      <Box>
        {' '}
        <Button
          title='Previous '
          className='btns rotate-left'
          data-testid='uc-paginate-arrow-left'
          type='button'
          disabled={value == 1}
          onClick={() => handleClick('previous')}
        >
          <SVGComponent iconName='Icon-arrow' />{' '}
          <span className='hide-elm'>Previous</span>{' '}
        </Button>{' '}
      </Box>{' '}
      <Box>
        {' '}
        <label className='m-0' htmlFor='paginate-count'>
          {' '}
          <TextField
            id='paginate-count'
            data-testid='uc-input-paginate'
            variant='outlined'
            className='searchInput input-count'
            size='small'
            type='tel'
            value={value}
            onChange={(e) => handleChange(e.target.value)}
            onBlur={handleInputBlur}
          />{' '}
        </label>{' '}
      </Box>
      <Box className='btns'>
        <span title={array?.length} tabIndex={0}>
          Of {array?.length}{' '}
        </span>
      </Box>{' '}
      <Box>
        {' '}
        <Button
          title='Next '
          className='btns rotate-right ml-0'
          data-testid='uc-paginate-arrow-right'
          type='button'
          onClick={() => handleClick('next')}
          disabled={array.length === value}
        >
          <SVGComponent iconName='Icon-arrow' />{' '}
          <span className='hide-elm'>Next</span>{' '}
        </Button>{' '}
      </Box>{' '}
    </Box>
  );
}

export default PaginationBox;
